import { FormatMoneyToDisplay } from '../../helper/currency-helper';
import { TOP_STOCK_DETAILS } from '../../models/stock';

const TopEarningStockCard = ({ topEarningStocksDetails }: PropsType) => {
  return (
    <div className="col-span-full xl:col-span-6 bg-white shadow-lg rounded-sm border border-slate-200 ">
      <header className="px-5 py-4 border-b border-slate-100">
        <h2 className="font-semibold text-slate-800 ">Top Earning Stocks</h2>
      </header>
      <div className="p-3">
        {/* Table */}
        <div className="overflow-x-auto">
          <table className="table-auto w-full ">
            {/* Table header */}
            <thead className="text-xs uppercase text-slate-400 bg-slate-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-left">Company</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Revenue</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Trades</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Earning</div>
                </th>
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="text-sm font-medium divide-y divide-slate-100 ">
              {/* Row */}
              {topEarningStocksDetails.map((stockDetails) => (
                <tr key={stockDetails.company}>
                  <td className="p-2">
                    <div className="flex items-center">
                      <div className="text-slate-800 ">
                        {stockDetails.company}
                      </div>
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="text-center ">
                      {FormatMoneyToDisplay(stockDetails.revenue)}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="text-center">{stockDetails.noOfTrades}</div>
                  </td>
                  <td className="p-2">
                    <div className="text-center text-emerald-500">
                      {stockDetails.earningPercentage.toFixed(1)}%
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

type PropsType = {
  topEarningStocksDetails: TOP_STOCK_DETAILS[];
};

export default TopEarningStockCard;
